import type { PointerEvent } from 'react';

const CORNER_STYLES: Record<string, string> = {
    'top-left': 'top-0 left-0 cursor-nwse-resize',
    'top-right': 'top-0 right-0 cursor-nesw-resize',
    'bottom-left': 'bottom-0 left-0 cursor-nesw-resize',
    'bottom-right': 'bottom-0 right-0 cursor-nwse-resize',
};

interface ResizeCornerProps {
    direction: string;
    onStart: (e: PointerEvent) => void;
}

export function ResizeCorner({ direction, onStart }: ResizeCornerProps) {
    return (
        <div
            className={`absolute z-[5] w-3 h-3 ${CORNER_STYLES[direction]}`}
            onPointerDown={onStart}
        />
    );
}
